/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from "react";
import { Table, Alert, Button, Space, Form } from "antd";
import { ClearOutlined } from "@ant-design/icons";

import { HeaderForm } from "./HeaderForm";
import { Spinner } from "../../components/spinner/Spinner";
import { removeDuplicates } from "../../utils/utils";
import { OcurrenceModal } from "./OcurrencesModal";

import { useLocation, useSearchParams } from "react-router-dom";

import {
  useFetchOcurrences,
  useFilteredOcurrences,
  useFetchOcurrencesBy,
  useFilters,
} from "../../app/orders/mutations";

import { columns } from "./constants";
import "../../styles/orders/ordenes.scss";
import useState from "react-usestateref";

export const Ocurrences = () => {
  const _useFilteredOrders = useFilteredOcurrences();
  const { selectedFilters, removeFilter, resetFilters } =
    useFilters();

  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOcurrence, setSelectedOcurrence] = useState(null);
  const location = useLocation();

  const [queryParams, setQueryParams, lastQueryParams] = useState({});

  useEffect(() => {
    const id_orden = searchParams.get('id_orden');
    
    if (id_orden) {
      setQueryParams({ id_orden });
      setTimeout(() => {
        refetch();
      }, 500);
    }
  }, [searchParams]);

  let {
    isFetching: isLoading,
    isError,
    error,
    ocurrences: orders,
    refetch,
  } = useFetchOcurrences(lastQueryParams.current);

  const handleSubmit = async (queries) => {
    setQueryParams(queries);
    resetFilters();
    localStorage.removeItem("CURRENT_ORDER");
    setTimeout(() => {
      refetch();
    }, 500);
  };

  useEffect(() => {
    resetFilters();
    localStorage.setItem("PREV_PAGE", 'ocurrences');
  }, [location]);

  let key =
    _useFilteredOrders?.length === 0
      ? orders
      : _useFilteredOrders !== -1
      ? _useFilteredOrders
      : [];

  if (isError && error instanceof Error)
    return (
      <Alert
        message="Ocurrión un error"
        description={error.message}
        type="error"
        showIcon
      />
    );

  const clientsDocuments =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.cedula))
      : [];

  const clientsOrders =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.pedido))
      : [];

  const NOVEDADES =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.novedad))
      : [];

  const PRIORIDADES =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.prioridad))
      : [];

  const RESPONSABLES =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.responsable))
      : [];

  const FECHAS_CIERRE =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.fechaCierre))
      : [];

  const STATUSES_FILTER = removeDuplicates(key?.map((o) => o.estado)).map(
    (o) => {
      return {
        value: o.toUpperCase(),
        label: o.toUpperCase(),
      };
    }
  );

  const handleFilterClose = (filter) => {
    if (!filter) return;
    removeFilter(filter);
    useFetchOcurrencesBy();
  };

  const handleFilterReset = () => {
    resetFilters();
    form.setFieldValue("fechaInicioPromesa", null);
    useFetchOcurrencesBy();
  };

  const handleDelete = (record) => {
    setIsModalVisible(true);
    setSelectedOcurrence(record);
  };

  return (
    <>
      <div className="orders">
        <div className="orders-header">
          <h2>Gestión de Novedades</h2>
        </div>
        <div className="orders-form">
          <HeaderForm
            onSubmit={handleSubmit}
            disabled={orders.length === 0 ? true : false}
            ordersIds={clientsOrders}
            documentsIds={clientsDocuments}
            statuses={STATUSES_FILTER}
            novedades={NOVEDADES}
            prioridades={PRIORIDADES}
            responsables={RESPONSABLES}
            fechasCierre={FECHAS_CIERRE}
            form={form}
          />
        </div>

        <div className="orders-filters">
          {selectedFilters && selectedFilters.length > 0 && (
            <Button
              id="clear-filters-btn"
              type="link"
              icon={<ClearOutlined />}
              onClick={handleFilterReset}
            >
              Limpiar Filtros
            </Button>
          )}

          {selectedFilters?.map((filter, index) => (
            <div className="tag-closable">
              {filter.label}: <b>{filter.value}</b>
              <button onClick={() => handleFilterClose(filter)}>x</button>
            </div>
          ))}
        </div>

        <div className="orders-table">
          <div className="orders-table-content">
            {isLoading && <Spinner tip="Cargando, por favor espere..." />}
            {!isLoading && (
              <Table
                columns={[
                  ...columns,
                  {
                    title: "Acciones",
                    dataIndex: "acciones",
                    key: "acciones",
                    fixed: "right",
                    width: 100,
                    render: (_, record) => (
                      <Space size="middle">
                        <Button
                          type="link"
                          disabled={
                            record.estado && record.estado === "ABIERTA"
                              ? false
                              : true
                          }
                          onClick={() => handleDelete(record)}
                        >
                          Cerrar
                        </Button>
                      </Space>
                    ),
                  },
                ]}
                dataSource={key}
                locale={{ emptyText: "No hay datos correspondientes" }}
                scroll={{ x: 2500 }}
              />
            )}
          </div>
          <OcurrenceModal
            isModalVisible={isModalVisible}
            selectedOcurrence={selectedOcurrence}
            onCloseModal={() => setIsModalVisible(false)}
          />
        </div>
      </div>
    </>
  );
};
